import React from 'react';

const HOME_NAV = [
  {
    name: 'HOME',
    to: '/',
    children: 'HOME',
    className: `menu-item ${window.location.pathname === '/' ? 'menu-item-active' : ''}`,
  },
  // {
  //   name: 'G2G',
  //   to: '/g2g',
  //   children: 'G2G',
  //   className: `menu-item ${window.location.pathname === '/g2g' ? 'menu-item-active' : ''}`,
  // },
  {
    name: 'SOFTWARE',
    to: '',
    children: 'SOFTWARE',
    className: `menu-item menu-sub-software ${window.location.pathname.includes('/software') ? 'menu-item-active' : ''}`,
  },
  {
    name: 'DATA PORTAL',
    to: '',
    children: 'DATA PORTAL',
    className: `menu-item menu-sub-portal ${window.location.pathname.includes('/data') || window.location.pathname.includes('/meta') ? 'menu-item-active' : ''}`,
  },
  {
    name: 'SMR PORTAL',
    to: 'https://yanglab.westlake.edu.cn/smr-portal/',
    children: 'SMR PORTAL',
    className: `menu-item`,
  },
  // {
  //   name: 'ABOUT',
  //   to: '/about',
  //   children: 'ABOUT',
  //   className: `menu-item ${window.location.pathname === '/about' ? 'menu-item-active' : ''}`,
  // },
];

export const NavDataSource = {
  isScrollLink: true,
  wrapper: { className: `header home-page-wrapper home-editor-css` },
  page: { className: 'home-page' },
  logo: {
    className: 'header-logo',
    children: '/assets/images/westlake-logo.png'
  },
  LinkMenu: {
    className: 'header-menu',
    children: HOME_NAV
  },
  mobileMenu: { className: 'header-mobile-menu' },
  Menu: {
    children: [
      {
        name: 'Banner3_0',
        to: 'Banner3_0',
        children: '首页',
        className: 'active menu-item',
      },
      {
        name: 'Content8_0',
        to: 'Content8_0',
        children: '特邀嘉宾',
        className: 'menu-item',
      },
      {
        name: 'Content9_0',
        to: 'Content9_0',
        children: '会议日程',
        className: 'menu-item',
      },
      {
        name: 'Content10_0',
        to: 'Content10_0',
        children: '大会地址',
        className: 'menu-item',
      },
      {
        name: 'Content11_0',
        to: 'Content11_0',
        children: '展台展示',
        className: 'menu-item',
      },
      {
        name: 'Content12_0',
        to: 'Content12_0',
        children: '特别鸣谢',
        className: 'menu-item',
      },
    ],
  },
};

export const FooterDataSource = {
  wrapper: { className: 'home-page-wrapper footer-wrapper' },
  OverPack: { className: 'footer', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://zos.alipayobjects.com/rmsportal/qqaimmXZVSwAhpL.svg',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: 'Animation specification and components of Ant Design.',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>回收项目</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '#',
              children: (
                <span>
                  <span>
                    <span>
                      <p>电梯回收</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              name: 'link1',
              href: '#',
              children: (
                <span>
                  <p>铁铝铜回收</p>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '#',
              children: (
                <span>
                  <p>不锈钢回收</p>
                </span>
              ),
            },
            {
              name: 'link3',
              href: '#',
              children: (
                <span>
                  <p>工程拆除</p>
                </span>
              ),
            },
            {
              name: 'link4',
              href: '#',
              children: (
                <span>
                  <p>中央空调回收</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: { children: '关于' },
        childWrapper: {
          children: [
            { href: '#', name: 'link0', children: 'FAQ' },
            { href: '#', name: 'link1', children: '联系我们' },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <span>
                <p>关注我们</p>
              </span>
            </span>
          ),
          className: 'k9h7k134cu-editor_css',
        },
        childWrapper: {
          children: [
            {
              name: 'image~k9h7il8htc6',
              className: 'k9h7irl6jgj-editor_css',
              children:
                'https://zos.alipayobjects.com/rmsportal/HzvPfCGNCtvGrdk.png',
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        © 2022 <a href="https://www.wllsb.edu.cn/" target="_blank" rel="noopener noreferrer">Westlake Laboratory</a>. 
        All Rights Reserved
      </span>
    ),
  },
};

export const MENU_SUB_LIST = {
  '/software-gcta': 'GCTA',
  '/software-smr': 'SMR',
  '/software-gsmr': 'GSMR',
  '/software-osca': 'OSCA',
  '/software-thistle': 'THISTLE',
  '/meta': 'BrainMeta',
  '/data': 'fastGWA'
};
